/** 活动详情简洁路由：contestId、seasonId 配置在 meta，复用 game-data 组件 */
const gameDataMeta = {
  IndexHeader: true,
  itemIndex: 1,
  needScroll: true
}

export default [
  // 需要发布活动时在此追加路由
  {
    path: '/GCEP',
    name: 'GCEP',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1836884756814471168',
      seasonId: '1858319691983056896'
    }
  },
  {
    path: '/CNEC',
    name: 'CNEC',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1017697392442650626',
      seasonId: '1889863159167283200'
    }
  },
  {
    path: '/BioGenius-X',
    name: 'BioGenius-X',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1728888799716667392',
      seasonId: '1852901662600048640'
    }
  },
  {
    path: '/iHOSA',
    name: 'iHOSA',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '908868162978848767',
      seasonId: '1890859756151746560'
    }
  },
  {
    path: '/CBPA',
    name: 'CBPA',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1127419795642359808',
      seasonId: '1890966162771124224'
    }
  },
  {
    path: '/ESB',
    name: 'ESB',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1365056780450922496',
      seasonId: '1783610319445389312'
    }
  },
  {
    path: '/SIC',
    name: 'SIC',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '908868162978848768',
      seasonId: '1860163424869265408'
    }
  },
  {
    path: '/CNAD',
    name: 'CNAD',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1652123740634460160',
      seasonId: '1785813464774836224'
    }
  },
  {
    path: '/CNAP',
    name: 'CNAP',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1652124047502442496',
      seasonId: '1785844205319467008'
    }
  },
  {
    path: '/CNAT',
    name: 'CNAT',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1652124208219779072',
      seasonId: '1785845266902003712'
    }
  },
  {
    path: '/CAQT',
    name: 'CAQT',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1166810017144320000',
      seasonId: '1655014207462273024'
    }
  },
  {
    path: '/Hi-World',
    name: 'Hi-World',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1165469564478259200',
      seasonId: '1810101069783609344'
    }
  },
  {
    path: '/WYF-FLALS',
    name: 'WYF-FLALS',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1753169152111124480',
      seasonId: '1864626457033154560'
    }
  },
  {
    path: '/NSL',
    name: 'NSL',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1017697405835063297',
      seasonId: '1760869604466585600'
    }
  },
  {
    path: '/CNCC',
    name: 'CNCC',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1322628364858654720',
      seasonId: '1807151163641012224'
    }
  },
  {
    path: '/WYF-FELS-HK',
    name: 'WYF-FELS-HK',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1613655096896262144',
      seasonId: '1859778628116656128'
    }
  },
  {
    path: '/WYF-FELS-UK',
    name: 'WYF-FELS-UK',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1885061005764042752',
      seasonId: '1885173350532349952'
    }
  },
  {
    path: '/EconPlus',
    name: 'EconPlus',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1555397886714540032',
      seasonId: '1811917533046075392'
    }
  },
  {
    path: '/MICOS',
    name: 'MICOS',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1845259483060740096',
      seasonId: '1857524838869204992'
    }
  },
  {
    path: '/BSSD',
    name: 'BSSD',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1874929181238861824',
      seasonId: '1874951565698244608'
    }
  },
  {
    path: '/AIY',
    name: 'AIY',
    component: () => import(/* webpackChunkName: "Index" */ '@/components/index/game-data'),
    meta: {
      ...gameDataMeta,
      contestId: '1887294962245152768',
      seasonId: '1887355469983490048'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/activity-short.js